import urlJoin from 'url-join';
import * as moment from 'moment';

export abstract class Util {
  static MIN_DATE = moment('0001-01-01');
  static HOST_KEY = 'EEPAY_UI_HOST_KEY';
  static DEFAULT = '/';

  static prependHost(path: string, baseHref: string = window[Util.HOST_KEY] || Util.DEFAULT): string {
    // `window[HOST_KEY]` is guaranteed to end in '/' if defined, remove redundant '/' from src
    if (path && path.length && path[0] === '/') {
      path = path.slice(1);
    }
    return urlJoin(baseHref, path);
  }

  static removeOutletFromUrl(url: string) {
    return url.replace(/ *\([^)]*\) */g, '');
  }

  static buildUrl(baseUrl: string, useExternalHandler: boolean, ultiproUrl: string, externalUrlPrefix: string, serverKey: string): string {
    let url = baseUrl;
    if (useExternalHandler){
        url = urlJoin(ultiproUrl, externalUrlPrefix, serverKey);
    }
    return url;
  }
}
